import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { cn } from "../../lib/utils";

const mockNotices = [
  {
    id: "1",
    title: "Soft Launch",
    date: "2025-03-02",
    isOpen: true,
  },
];


export function NoticeView() {
  return (
    <div className="space-y-4">
      {mockNotices.map((notice) => (
        <Card key={notice.id} className={cn(!notice.isOpen && "opacity-60")}>
          <CardContent className="flex items-center justify-between p-4">
            <div>
              <div className="text-sm text-muted-foreground">{notice.date}</div>
              <h3 className="font-medium">{notice.title}</h3>
            </div>
            <Button variant="ghost" size="sm">
              {notice.isOpen ? "Close" : "Closed"}
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
